/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Get the type of the value, that the Promise holds.
 */
export type PromiseTypeReturnTypeTypeoffeedbackServiceSubmitFeedback = FeedbackReturnType;

/**
 * Get the return type of a function which returns a Promise.
 */
export type PrismaPromiseReturnTypeTypeoffeedbackServiceSubmitFeedback =
  PromiseTypeReturnTypeTypeoffeedbackServiceSubmitFeedback;

export type FeedbackReturnType = PrismaPromiseReturnTypeTypeoffeedbackServiceSubmitFeedback;

/**
 * Get the type of the value, that the Promise holds.
 */
export type PromiseTypeReturnTypeTypeofgeneServiceGetGenes = {
  description: string;
  ENSEMBL_gene_ID: string;
  gene: string;
}[];

/**
 * Get the return type of a function which returns a Promise.
 */
export type PrismaPromiseReturnTypeTypeofgeneServiceGetGenes = PromiseTypeReturnTypeTypeofgeneServiceGetGenes;

export type GeneHeaders = PrismaPromiseReturnTypeTypeofgeneServiceGetGenes;

/**
 * Get the type of the value, that the Promise holds.
 */
export type PromiseTypeReturnTypeTypeofgeneServiceGetFeaturedGenes = { gene: string }[];

/**
 * Get the return type of a function which returns a Promise.
 */
export type PrismaPromiseReturnTypeTypeofgeneServiceGetFeaturedGenes =
  PromiseTypeReturnTypeTypeofgeneServiceGetFeaturedGenes;

export type FeaturedGenes = PrismaPromiseReturnTypeTypeofgeneServiceGetFeaturedGenes;

/**
 * Model Transcript
 */
export interface Transcript {
  ENSEMBL_gene_ID: string;
  ENSEMBL_transcript_ID: string;
}

/**
 * Get the type of the value, that the Promise holds.
 */
export interface PromiseTypeReturnTypeTypeofgeneServiceGetGeneDetail {
  transcripts: (Transcript & {
    sgRNAs: {
      wells: {
        well: {
          images: {
            score: number;
            rating: number;
            filtered_cells: number;
            detected_nuclei: number;
            detected_cells: number;
            measurement_ID: number;
            FOV: number;
            image_ID: number;
          }[];
          column: number;
          row: number;
          plate_ID: number;
          experiment_ID: string;
          well_ID: number;
        };
      }[];
      sequence: string;
      strand: string;
      end: string;
      start: string;
      chromosome: string;
      intron: number;
      frame: number;
      sgRNA_ID: string;
    }[];
  })[];
  description: string;
  ENSEMBL_gene_ID: string;
  gene: string;
}

/**
 * Get the return type of a function which returns a Promise.
 */
export type PrismaPromiseReturnTypeTypeofgeneServiceGetGeneDetail = PromiseTypeReturnTypeTypeofgeneServiceGetGeneDetail;

export type GeneDetail = PrismaPromiseReturnTypeTypeofgeneServiceGetGeneDetail;

/**
 * Get the type of the value, that the Promise holds.
 */
export interface PromiseTypeReturnTypeTypeofgeneServiceGetWells {
  transcripts: (Transcript & {
    sgRNAs: {
      wells: {
        well: {
          images: {
            score: number;
            rating: number;
            filtered_cells: number;
            detected_nuclei: number;
            detected_cells: number;
            measurement_ID: number;
            FOV: number;
            image_ID: number;
          }[];
          column: number;
          row: number;
          plate_ID: number;
          experiment_ID: string;
          well_ID: number;
        };
        frame: number;
      }[];
      frame: number;
      sgRNA_ID: string;
    }[];
  })[];
  description: string;
  gene: string;
}

/**
 * Get the return type of a function which returns a Promise.
 */
export type PrismaPromiseReturnTypeTypeofgeneServiceGetWells = PromiseTypeReturnTypeTypeofgeneServiceGetWells;

export type GeneWells = PrismaPromiseReturnTypeTypeofgeneServiceGetWells;

/**
 * Model SearchTerm
 */
export interface SearchTerm {
  /** @format double */
  count: number;
  term: string;

  /** @format double */
  term_ID: number;
}

/**
 * Model GeneViewing
 */
export interface GeneViewing {
  /** @format double */
  count: number;
  ENSEMBL_gene_ID: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  private addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  private addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
            ? JSON.stringify(property)
            : `${property}`
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  private mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
        ...(requestParams.headers || {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : void 0,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title intron-tagging-backend
 * @version 1.0.0
 * @license ISC
 * @baseUrl /
 * @contact Pavel Ruzicka «PRuzicka@cemm.oeaw.ac.at»
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  feedback = {
    /**
     * No description
     *
     * @name UpvoteImage
     * @request PUT:/feedback/score/{image_ID}/upvote
     */
    upvoteImage: (imageId: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feedback/score/${imageId}/upvote`,
        method: "PUT",
        ...params,
      }),

    /**
     * No description
     *
     * @name DownvoteImage
     * @request PUT:/feedback/score/{image_ID}/downvote
     */
    downvoteImage: (imageId: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/feedback/score/${imageId}/downvote`,
        method: "PUT",
        ...params,
      }),

    /**
     * No description
     *
     * @name SubmitFeedback
     * @request POST:/feedback/feedback/{image_ID}
     */
    submitFeedback: (
      imageId: number,
      data: { submitter?: string; frame: number; sgRNA_ID: string; feedbackEntries: Record<string, string | boolean> },
      params: RequestParams = {}
    ) =>
      this.request<{ feedback: FeedbackReturnType } | any, void>({
        path: `/feedback/feedback/${imageId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  genes = {
    /**
     * No description
     *
     * @name GetGenes
     * @request GET:/genes
     */
    getGenes: (params: RequestParams = {}) =>
      this.request<{ genes: GeneHeaders }, any>({
        path: `/genes`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetFeaturedGenes
     * @request GET:/genes/featured
     */
    getFeaturedGenes: (params: RequestParams = {}) =>
      this.request<{ genes: FeaturedGenes }, any>({
        path: `/genes/featured`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetGeneDetail
     * @request GET:/genes/{gene_ID}
     */
    getGeneDetail: (geneId: string, params: RequestParams = {}) =>
      this.request<{ gene: GeneDetail | null }, void>({
        path: `/genes/${geneId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetWells
     * @request GET:/genes/{gene_ID}/{sgRNA_ID}
     */
    getWells: (geneId: string, sgRnaId: string, params: RequestParams = {}) =>
      this.request<{ wells: GeneWells | null }, void>({
        path: `/genes/${geneId}/${sgRnaId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  stats = {
    /**
     * No description
     *
     * @name GetIntroStats
     * @request GET:/stats
     */
    getIntroStats: (params: RequestParams = {}) =>
      this.request<{ stats: { imageCount: number; wellCount: number; geneCount: number } }, any>({
        path: `/stats`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RecordSearchTerm
     * @request POST:/stats/search
     */
    recordSearchTerm: (query: { searchTerm: string }, params: RequestParams = {}) =>
      this.request<{ searchTerm: SearchTerm }, any>({
        path: `/stats/search`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RecordGeneView
     * @request POST:/stats/gene
     */
    recordGeneView: (query: { gene_ID: string }, params: RequestParams = {}) =>
      this.request<any | { geneViewing: GeneViewing }, void>({
        path: `/stats/gene`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),
  };
}
